var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CommunicationService } from '../../services/communication/communication.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../services/modal/modal.service';
import { UserService } from '../../services/user.service';
import { AbstractAchooComponent } from '../abstract-achoo.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppSettings } from '../../utils/app-settings';
import { Router } from '@angular/router';
import { DateUtils } from '../../utils/date.utils';
var InfluencerInboxComponent = /** @class */ (function (_super) {
    __extends(InfluencerInboxComponent, _super);
    function InfluencerInboxComponent(influencerInboxService, userService, router, modalService, deviceService) {
        var _this = _super.call(this, userService) || this;
        _this.influencerInboxService = influencerInboxService;
        _this.userService = userService;
        _this.router = router;
        _this.modalService = modalService;
        _this.deviceService = deviceService;
        _this.editingMessages = false;
        _this.currentOffset = 0;
        _this.showActivityLog = true;
        _this.startLoadingTime = DateUtils.now();
        return _this;
    }
    InfluencerInboxComponent.prototype.ngOnInit = function () {
        // prevent user access to inbox when it's disabled
        if (AppSettings.isDisableChat()) {
            // in new influencer app
            if (this.userService.isInfluencer) {
                return this.router.navigate(['dashboard', 'influencer', 'details']);
            }
            else {
                return this.router.navigate(['discover']);
            }
        }
        _super.prototype.ngOnInit.call(this);
    };
    InfluencerInboxComponent.prototype.companyChangeCallback = function (companyId) {
        this.conservationList = [];
        this.selectedConversation = null;
        this.currentOffset = 0;
        this.loadConservationList(companyId);
    };
    InfluencerInboxComponent.prototype.fetchNextConversation = function () {
        this.loadConservationList(this.companyId);
    };
    InfluencerInboxComponent.prototype.editMessages = function (e) {
        if (e) {
            e.preventDefault();
        }
        this.editingMessages = !this.editingMessages;
    };
    Object.defineProperty(InfluencerInboxComponent.prototype, "unReadMessageCounting", {
        get: function () {
            return (this.conservationList || []).filter(function (x) {
                return x.status === 1;
            }).length;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerInboxComponent.prototype.onConfirmRemoveConversation = function (con) {
        if (!con) {
            return;
        }
        this.conversationToRemove = con;
        this.modalService.openInCenter(this.confirmRemoveMessageDialog);
    };
    InfluencerInboxComponent.prototype.confirmBeforeRemovingConversation = function () {
        var _this = this;
        this.modalService.close();
        if (this.conversationToRemove) {
            this.influencerInboxService.deleteConversation(this.companyId, this.conversationToRemove.id).subscribe(function (res) {
                _this.conservationList = _this.conservationList.filter(function (c) { return c.id !== _this.conversationToRemove.id; });
                // in case, delete the active conversation, set the first one as active
                if (_this.conversationToRemove.id === _this.selectedConversation.id) {
                    if (_this.conservationList.length > 0) {
                        _this.selectedConversation = _this.conservationList[0];
                        _this.activateConversation(_this.selectedConversation);
                    }
                    else {
                        _this.selectedConversation = null;
                    }
                }
                _this.conversationToRemove = null;
            });
        }
    };
    InfluencerInboxComponent.prototype.closeConfirmRemoveConversation = function () {
        this.modalService.close();
    };
    InfluencerInboxComponent.prototype.onSelectConversation = function (con) {
        if (con && (!this.selectedConversation || (this.selectedConversation && con.id !== this.selectedConversation.id))) {
            this.activateConversation(con);
            var lastMessageId = con.messages.length > 0 ? con.messages[con.messages.length - 1].id : null;
            this.onReadLastMessages({
                conversationId: con.id,
                lastMessageId: lastMessageId
            });
        }
    };
    InfluencerInboxComponent.prototype.isAMessageSelected = function () {
        return !!this.selectedConversation;
    };
    InfluencerInboxComponent.prototype.backToInbox = function () {
        this.selectedConversation = null;
    };
    Object.defineProperty(InfluencerInboxComponent.prototype, "sortedConversationList", {
        get: function () {
            var _this = this;
            if (!this.conservationList) {
                return [];
            }
            var sortedConversationList = this.conservationList;
            if (this.searchContent && this.searchContent !== '') {
                sortedConversationList = this.conservationList.filter(function (c) { return c.name.toLowerCase().indexOf(_this.searchContent.toLowerCase()) >= 0; });
            }
            return sortedConversationList;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Callback after user read the new unreaded messages
     * @param conversationId
     */
    InfluencerInboxComponent.prototype.onReadLastMessages = function (data) {
        var _this = this;
        // stop processing if missing required params
        if (!data.conversationId || !data.lastMessageId) {
            return;
        }
        this.influencerInboxService.markMessageAsSeen(this.userService.getCompanyId(), data.conversationId, data.lastMessageId)
            .subscribe(function (res) {
            var con = _this.conservationList.find(function (c) { return c.id === data.conversationId; });
            if (con) {
                con.status = 0 /* Normal */;
            }
            // executed callback after marking the last message as seen
            if (data.callback) {
                data.callback();
            }
        });
    };
    /**
     * Callback after some new messages were loaded
     * @param conversationId
     */
    InfluencerInboxComponent.prototype.newMessageAdded = function (data) {
        var con = this.conservationList.find(function (c) { return c.id === data.conversationId; });
        if (con) {
            con.status = data.status;
            con.messages = [data.lastMessage];
            con.lastUpdated = data.lastMessage.sentTime;
        }
        this.conservationList.sort(function (c1, c2) {
            return c2.lastUpdated > c1.lastUpdated ? 1 : c2.lastUpdated < c1.lastUpdated ? -1 : 0;
        });
    };
    InfluencerInboxComponent.prototype.getActiveConversationName = function (con) {
        return this.influencerInboxService.normalizeConversationName(con);
    };
    InfluencerInboxComponent.prototype.loadConservationList = function (companyId) {
        var _this = this;
        var isFirstPage = this.currentOffset === 0;
        this.influencerInboxService.fetchConservationList(companyId, this.currentOffset, this.startLoadingTime)
            .subscribe(function (res) {
            _this.conservationList = _this.conservationList.concat(res.conversations);
            _this.currentOffset = res.offset;
            // don't show the latest conversation on mobile
            if (_this.deviceService.isMobile()) {
                return;
            }
            if (_this.selectedConversation) {
                _this.onSelectConversation(_this.selectedConversation);
            }
            else if (_this.conservationList.length > 0) {
                _this.onSelectConversation(_this.conservationList[0]);
            }
        });
    };
    InfluencerInboxComponent.prototype.activateConversation = function (conversation) {
        // optimistic UI, show selected convos immediately after user select.
        // just waiting for API to update message and permission
        this.selectedConversation = Object.assign({}, conversation, {
            messages: [],
            permission: null
        });
        this.conservationList.forEach(function (convo) { return convo.isSelected = convo.id === conversation.id; });
    };
    return InfluencerInboxComponent;
}(AbstractAchooComponent));
export { InfluencerInboxComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer-inbox/influencer-inbox.component.ts.pre-build-optimizer.js